import React, { createContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const {
    product: data,
    isLoading: loading,
    isError,
    message,
  } = useSelector((state) => state.product);
  const [selectedCategory, setSelectedCategory] = React.useState("");

  useEffect(() => {
    if (data.length === 0) {
      dispatch(getAllProducts());
    }
  }, [dispatch, data.length]);

  const filteredProducts = React.useMemo(() => {
    if (!selectedCategory) return data;
    return data.filter(
      (p) =>
        p.category === selectedCategory || p.subcategory === selectedCategory,
    );
  }, [data, selectedCategory]);

  // Stub for components that might expect this
  const setSubcategory = () => {};

  return (
    <DataContext.Provider
      value={{
        data,
        loading,
        error: isError ? { message } : null,
        selectedCategory,
        setSelectedCategory,
        filteredProducts,
        setSubcategory,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
